module.exports = new Promise(async (resolve, reject) => {
  try {
    const module = await import('undefined/assets/remoteEntry.js?t=1761548120434');
    resolve(module);
  } catch (error) {
    // console.error('Failed to load remote:', error);
    resolve(null);
  }
})
;